<template>
    <div>
        <p v-if="getChangedStore1 && (ltype=='1')">{{readFromStore()}}</p>
        <p v-if="getChangedStore2 && (ltype=='2')">{{readFromStore()}}</p>
        <p v-if="getRefresh1 && (ltype=='1')">{{refreshData()}}</p>
        <p v-if="getRefresh2 && (ltype=='2')">{{refreshData()}}</p>
        <p v-if="getAddElement > 0 && !getRefresh1 && !getRefresh2">{{addElement()}}</p>
        <p v-if="getDeleteElement && !getRefresh1 && !getRefresh2">{{deleteElement()}}</p>
        
        
        <div v-if = "mycontent">
            <v-flex xs12>
                <v-text-field
                    v-model="mycontent.title"
                    label="Title:"
                ></v-text-field>  
            </v-flex>    

            <div>
                    <div>
                        <v-toolbar dense @click="changeCollapse('assignment')" style="color:white">
                        <v-app-bar-nav-icon></v-app-bar-nav-icon>
                             <v-toolbar-title>Assignment ({{mycontent.assignment.length}} chars)</v-toolbar-title>
                        </v-toolbar>
                        <div v-if="getProgramElements.assignment.collapse">
                            <v-flex xs12 >
                                <quill-editor v-model='mycontent.assignment' :options="getEditorOption()">
                                </quill-editor>
                            </v-flex>
                            <v-flex xs12 justify-end>
                                <v-btn @click="showHtmlC">Show HTML</v-btn>
                                <v-btn v-if="showedHtmlC" @click="updateC">Update</v-btn>
                            </v-flex>
                            <v-textarea v-if="showedHtmlC" v-model=HtmlContent>
                            </v-textarea>
                        </div>
                    </div>

                    <div v-if="getProgramElements.files.show">
                        <v-toolbar dense @click="changeCollapse('files')" style="color:white">
                        <v-app-bar-nav-icon></v-app-bar-nav-icon>
                             <v-toolbar-title>Files ({{files.files.length}} file(s))</v-toolbar-title>
                        </v-toolbar>
                        <div v-if="getProgramElements.files.collapse">
                            <v-tabs
                                center-active 
                                color="blue" slider-color="blue"
                                class="customTabTitle"
                                >
                                <v-icon v-if="ltype=='1'" @click="addElementEvent(1)">mdi-plus-circle-outline</v-icon>
                                <v-tab v-for="(filename, index) in files.files" :key="index" @click="setActiveContent(1,index)">                                    
                                    {{filename}} &nbsp;
                                    <v-icon v-if="ltype=='1'" small @click="editTab(1,index)">mdi-pencil</v-icon>
                                    <v-icon v-if="ltype=='1' && index>0" small @click="deleteElementEvent(1,index)">mdi-delete</v-icon>
                                </v-tab>
                            </v-tabs>
                            <v-text-field
                                v-if="editNo == 1"
                                label="Change name (and press Enter)"
                                v-model="chanName.name"
                                @keydown.enter.prevent="changeTabName(1)"
                                @keydown.esc.prevent="editNo = 0"
                            ></v-text-field>
                            <v-toolbar dense style="color:white">                        
                                <v-toolbar-title>Requested file(s):</v-toolbar-title>
                                
                            </v-toolbar>
                            <codemirror class="border-top" ref="myCm" v-model="mycontent.files[activeIndexFiles_files].rContent" 
                                            :options="getCmOptions()"
                                            >
                            </codemirror>
                            <v-toolbar dense style="color:white">                        
                                <v-toolbar-title>Authors solution:</v-toolbar-title>
                                
                                <v-spacer></v-spacer>
                                <v-btn outlined style="magrin-right:50px;">{{grade}}%</v-btn>
                                <v-icon @click="showCompileInfo = !showCompileInfo" :color="getCompilerColor()" style="margin:5px;">build</v-icon>
                                <v-icon @click="showExecuteInfo = !showExecuteInfo" :color="getResultColor()" large style="magrin-right:10px;">reorder</v-icon>
                                <v-icon @click="runCode()" color="green" large style="magrin-right:5px;">check_circle_outline</v-icon>
                            </v-toolbar>
                            <v-card v-if="vplProcessInfo>''">
                                <v-card-text>
                                    {{vplProcessInfo}}
                                </v-card-text>     
                            </v-card>
                            <v-card v-if="showCompileInfo">
                                <v-card-text>
                                    <span v-html="vplCompilerInfo"></span>
                                </v-card-text>     
                            </v-card>
                            <v-card v-if="showExecuteInfo">
                                <v-card-text>
                                    <span v-html="vplExecutionInfo"></span>
                                </v-card-text>     
                            </v-card>

                            <codemirror class="border-top" ref="myCm2" v-model="mycontent.files[activeIndexFiles_files].aContent" 
                                            :options="getCmOptions()"
                                            >
                            </codemirror>
                        </div>
                    </div>

                    <div v-if="getProgramElements.testCases.show">
                        <v-toolbar dense @click="changeCollapse('testCases')" style="color:white">
                        <v-app-bar-nav-icon></v-app-bar-nav-icon>
                             <v-toolbar-title>Test cases ({{mycontent.testCases.length}} chars)</v-toolbar-title>
                        </v-toolbar>
                        <div v-if="getProgramElements.testCases.collapse">
                            <codemirror class="border-top" ref="myCm3" v-model="mycontent.testCases" 
                                :options="getCmOptions()"
                                >
                            </codemirror>
                        </div>
                    </div>

                    <div v-if="getProgramElements.filesToKeep.show">
                        <v-toolbar dense @click="changeCollapse('filesToKeep')" style="color:white">
                        <v-app-bar-nav-icon></v-app-bar-nav-icon>
                             <v-toolbar-title>Files to keep ({{files.filesToKeep.length}} file(s))</v-toolbar-title>
                        </v-toolbar>
                        <input 
                                        type="file"
                                        ref="fileInput"
                                        style="display:none"
                                        @change="onFilePicked"
                                    >

                        <div v-if="getProgramElements.filesToKeep.collapse">
                        <v-btn dense small v-if="ltype==2" @click="copyKeep()" width="100%" style="magrins:5px">Copy keep files from primary (overwriting content)</v-btn>
                            <v-tabs
                                center-active 
                                color="blue" slider-color="blue"
                                class="customTabTitle"
                                >
                                <v-icon v-if="ltype=='1'" @click="addElementEvent(2)">mdi-plus-circle-outline</v-icon>
                                <v-tab v-for="(filename, index) in files.filesToKeep" :key="index" @click="setActiveContent(2,index)">                                    
                                    {{filename}} &nbsp;
                                    <v-icon v-if="ltype=='1'" small @click="editTab(2,index)">mdi-pencil</v-icon>
                                    <v-icon v-if="ltype=='1' && index>0" small @click="deleteElementEvent(2,index)">mdi-delete</v-icon>

                                    <v-icon v-if="filename.substring(filename.length-4) == '.bin'" 
                                        small 
                                        @click="onPickFile(index)"
                                        >
                                    input
                                    </v-icon>
                                </v-tab>
                            </v-tabs>
                            <v-text-field
                                v-if="editNo == 2"
                                label="Change name (and press Enter)"
                                v-model="chanName.name"
                                @keydown.enter.prevent="changeTabName(2)"
                                @keydown.esc.prevent="editNo = 0"
                            ></v-text-field>
                            <codemirror class="border-top" ref="myCm4" v-model="mycontent.filesToKeep[activeIndexFiles_keep]" 
                                :options="getCmOptions()"
                                >
                            </codemirror>
                        </div>
                    </div>

                    <div v-if="getProgramElements.configFiles.show">
                        <v-toolbar dense @click="changeCollapse('configFiles')" style="color:white">
                        <v-app-bar-nav-icon></v-app-bar-nav-icon>
                             <v-toolbar-title>Config files ({{files.configFiles.length}} file(s))</v-toolbar-title>
                        </v-toolbar>
                        <div v-if="getProgramElements.configFiles.collapse">
                        <v-btn dense small v-if="ltype==2" @click="copyConfig()" width="100%" style="magrins:5px">Copy config files from primary (overwriting content)</v-btn>
                            <v-tabs
                                center-active 
                                color="blue" slider-color="blue"
                                class="customTabTitle"
                                >
                                <v-icon v-if="ltype=='1'" @click="addElementEvent(3)">mdi-plus-circle-outline</v-icon>
                                <v-tab v-for="(filename, index) in files.configFiles" :key="index" @click="setActiveContent(3,index)">                                    
                                    {{filename}} &nbsp;
                                    <v-icon v-if="ltype=='1' && index > 2" small @click="editTab(3,index)">mdi-pencil</v-icon>
                                    <v-icon v-if="ltype=='1' && index > 2" small @click="deleteElementEvent(3,index)">mdi-delete</v-icon>
                                </v-tab>
                            </v-tabs>
                            <v-text-field
                                v-if="editNo == 3"
                                label="Change name (and press Enter)"
                                v-model="chanName.name"
                                @keydown.enter.prevent="changeTabName(3)"
                                @keydown.esc.prevent="editNo = 0"
                            ></v-text-field>
                            <codemirror class="border-top" ref="myCm5" v-model="mycontent.configFiles[activeIndexFiles_config]" 
                                :options="getCmOptions()"
                                >
                            </codemirror>
                        </div>
                    </div>
                                        
                    <div>
                        <v-toolbar dense @click="changeCollapse('help')" style="color:white">
                        <v-app-bar-nav-icon></v-app-bar-nav-icon>
                             <v-toolbar-title>Help ({{mycontent.help.length}} chars)</v-toolbar-title>
                        </v-toolbar>
                        <div v-if="getProgramElements.help.collapse">
                            <v-flex xs12 >
                                <quill-editor v-model="mycontent.help" :options="getEditorOption()">
                                </quill-editor>
                            </v-flex>
                            <v-flex xs12 justify-end>
                                <v-btn @click="showHtmlH">Show HTML</v-btn>
                                <v-btn v-if="showedHtmlH" @click="updateH">Update</v-btn>
                            </v-flex>
                            <v-textarea v-if="showedHtmlH" v-model=HtmlContent>
                            </v-textarea>
                        </div>
                    </div>

            </div>
        </div>
    </div>
</template>

<script>
import {mapGetters} from 'vuex'
import { codemirror } from 'vue-codemirror'
import 'codemirror/lib/codemirror.css'
import { quillEditor } from 'vue-quill-editor'
import configData from '../../config.js'
import axios from '../../axios-auth'
// import 'highlight.js/styles/routeros.css'
// import hljs from 'highlight.js'

export default {
    data() {
        return {
                binaryFileIndex : -1,
                files: {
                    files: ['loading...'],
                    filesToKeep: [],
                    configFiles: []
                },
                showedHtmlC : false,
                showedHtmlH : false,
                mycontent:  {
                    title: 'loading...',
                    assignment: 'loading...',
                    files: [{
                                rContent: '',
                                aContent : ''
                            }
                    ],                     
                    testCases: '',
                    filesToKeep: [ ],
                    configFiles: [ ],
                    help: ''                    
                },
                activeIndexFiles_files : 0, // content for active tab in files
                activeIndexFiles_keep : 0, // content for active tab in files
                activeIndexFiles_config : 0, // content for active tab in files
                HtmlContent: '',
                HtmlHelp: '',
                editNo: 0, // edit for change name
                chanName: {name:'', index:0}, // model for renaming
                vplProcessInfo: '',
                vplCompilerInfo: '',
                vplExecutionInfo: '',
                monitoringSocket: null, 
                isRunning: false,
                showCompileInfo: false,
                showExecuteInfo: false,
                grade: 0
              }
    },
    props: ['ltype','courseID'],
    computed: 
            mapGetters([
                            'getLanguagePrimary',   
                            'getLanguageSecondary',
                            'getLanguagePrimaryTmp',   
                            'getLanguageSecondaryTmp',
                            'getRefresh1',
                            'getRefresh2',
                            'getChangedStore1',
                            'getChangedStore2',
                            'getAddElement',
                            'getDeleteElement',
                            'getContent8',
                            'getFiles',
                            'getProgramElements'
                        ])
    ,
    components: {
        quillEditor,
        codemirror
    },
    methods: {
        showHtmlC() {
            this.showedHtmlC = !this.showedHtmlC
            this.HtmlContent = this.mycontent.assignment
        },
        showHtmlH() {
            this.showedHtmlH = !this.showedHtmlH
            this.HtmlHelp = this.mycontent.help
        },
        updateC() {
            this.mycontent.assignment = this.HtmlContent
        },
        updateH() {
            this.mycontent.help = this.HtmlHelp
        },

        /************************************************************ */
        editTab(tab, index) {
            switch (tab) {
                case 1 : this.editNo = 1
                         this.chanName.name = this.files.files[index]
                         break                        
                case 2 : this.editNo = 2
                         this.chanName.name = this.files.filesToKeep[index]
                         break                        
                case 3 : this.editNo = 3
                         this.chanName.name = this.files.configFiles[index]
                         break                        
            }
             this.chanName.index = index                         
        },
        //*************************************************************************** */
        changeTabName(tab) {
            switch (tab) {
                case 1 : this.editNo = 0
                         this.files.files[this.chanName.index] = this.chanName.name
                         break                        
                case 2 : this.editNo = 0
                         this.files.filesToKeep[this.chanName.index] = this.chanName.name
                         break                        
                case 3 : this.editNo = 0
                         this.files.configFiles[this.chanName.index] = this.chanName.name
                         break                        
            }

            this.$store.commit('setFiles',this.files) // to save all content              
        }, 

       /************************************************************ */
        addElementEvent(index) {
            this.$store.commit('setRefresh1',true) // to save all content
            this.$store.commit('setRefresh2',true)        
            this.$store.commit('setAddElement',index)
        },
        addElement() {
            var index = this.getAddElement
            this.$store.commit('setAddElement',0)
            this.$store.commit('addFiletoList',index)
        },
        deleteElementEvent(tab, index) {
            this.$store.commit('setRefresh1',true) // to save all content
            this.$store.commit('setRefresh2',true)        
            this.$store.commit('setDeleteElement', {tab: tab, index: index})
            if (tab == 1) {
                if (this.activeIndexFiles_files > this.files.files.length-2) this.activeIndexFiles_files = this.files.files.length-2      
            }
            if (tab == 2) {
                if (this.activeIndexFiles_keep > this.files.filesToKeep.length-2) this.activeIndexFiles_keep = this.files.filesToKeep.length-2
            }
            if (tab == 3) {
                if (this.activeIndexFiles_config > this.files.configFiles.length-2) this.activeIndexFiles_config = this.files.configFiles.length-2
            }
            this.editNo = 0
        },
        deleteElement() {
            var data = this.getDeleteElement
            this.$store.commit('setDeleteElement', null)
            this.$store.dispatch('deleteElementinList', data)           
        },
        /************************************************************ */
        setActiveContent(tab,index) {
            switch (tab) {
                case 1 : this.activeIndexFiles_files = index
                         break
                case 2 : this.activeIndexFiles_keep = index
                         break
                case 3 : this.activeIndexFiles_config = index
                         break
            }
            /* eslint-disable no-console */
            // console.log(this.activeIndexFiles_keep)
        },
        /************************************************************ */
        changeCollapse(text) {
            var myset = this.getProgramElements
            if (text == 'assignment') myset.assignment.collapse = !myset.assignment.collapse
            if (text == 'files') myset.files.collapse = !myset.files.collapse
            if (text == 'testCases') myset.testCases.collapse = !myset.testCases.collapse
            if (text == 'filesToKeep') myset.filesToKeep.collapse = !myset.filesToKeep.collapse
            if (text == 'configFiles') myset.configFiles.collapse = !myset.configFiles.collapse
            if (text == 'help') myset.help.collapse = !myset.help.collapse

            this.$store.commit('setProgramElements',myset)            
        },
        /************************************************************ */
        saveActualContent(mylang) {   
            this.$store.commit('setFiles', this.files)

            var data = {
                lang_id : mylang.id,
                content: this.mycontent
            }
            this.$store.commit('setContent8', data)            
        },

        refreshData() {
            // var lang = null
            if (this.ltype =='1') {
                this.$store.commit('setRefresh1',false)
                if (this.getLanguagePrimaryTmp) {
                    this.saveActualContent(this.getLanguagePrimaryTmp)
                }
                this.$store.commit('setChangedStore1',true)
            } else {
                this.$store.commit('setRefresh2',false)
                if (this.getLanguageSecondaryTmp)
                    this.saveActualContent(this.getLanguageSecondaryTmp)
                this.$store.commit('setChangedStore2',true)            
            }            
        },
        getContent8fromStore(lang_id) {
            return this.getContent8(lang_id)
        },

        readFromStore() {
            this.files = this.getFiles

            if (this.ltype == 1) {                
                this.$store.commit('setChangedStore1',false)
                this.mycontent = this.getContent8fromStore(this.getLanguagePrimary.id)
            }
            if (this.ltype == 2) {                
                this.$store.commit('setChangedStore2',false)
                this.mycontent = this.getContent8fromStore(this.getLanguageSecondary.id)
            }
            // console.log(this.mycontent)
        },
        getEditorOption() {
          return {
                modules: {
                    'toolbar': [
                    [{ 'header': '1' }, { 'header': '2' }],
                    [ 'bold', 'italic', 'underline', 'strike' ],
                    ['code-block','blockquote',  { 'color': [] }, { 'background': [] }],
                    [{ 'script': 'super' }, { 'script': 'sub' }],
                    [{ 'list': 'ordered' }, { 'list': 'bullet'}, { 'indent': '-1' }, { 'indent': '+1' }],
                    [{ 'align': [] }],
                    [ 'link', 'image', 'formula' ],
                    [ 'clean' ]
                    ],
         /*           syntax: {
                    highlight: text => hljs.highlightAuto(text).value
                    },
           */         imageDrop: true,
                    imageResize: true
                },
                theme: 'snow'
            }
        },
        runCode() {
          if (this.isRunning) return
          this.vplProcessInfo = ''  
          this.vplCompilerInfo = ''  
          this.vplExecutionInfo = ''  
          var submitted_files = []
          var keep_files = []
          var config_files = []

          for (let i=0; i<this.files.files.length; i++) {
              submitted_files.push( {
                  filename: this.files.files[i],
                  filecontent: this.mycontent.files[i].aContent
              })
          }

          for (let i=0; i<this.files.filesToKeep.length; i++) {
              keep_files.push( {
                  filename: this.files.filesToKeep[i],
                  filecontent: this.mycontent.filesToKeep[i]
              })
          }
          for (let i=0; i<this.files.configFiles.length; i++) {
              config_files.push( {
                  filename: this.files.configFiles[i],
                  filecontent: this.mycontent.configFiles[i]
              })
          }

          let data = {
              course_id: this.courseID,
              submitted_files: JSON.stringify(submitted_files),
              keep_files: JSON.stringify(keep_files),
              config_files: JSON.stringify(config_files),
              testCases: this.mycontent.testCases
          }

          // console.log(data)
          axios.post('/vpl-run-test', data, this.$store.getters.getAxiosConfig )
          .then((res) => {
            // set data to var
            // console.log(res.data)
            this.readVPLAnswer(res.data);
         //   console.log(res.data)
          })
          .catch(error => {
         //     console.log("error")
            this.$store.commit('setFeedback', error)
        })

         // eslint-disable-next-line 
         // console.log(data)
        },
        readVPLAnswer(tickets) {
            this.showCompileInfo = false
            this.showExecuteInfo = false
           // var arr = []
            let monitoringTarger = configData.jailSocketConnection + tickets.monitorticket+'/monitor';

            this.vplProcessInfo = 'awaiting connection... '
            this.monitoringSocket = new WebSocket(monitoringTarger);

            this.monitoringSocket.onopen = () => {
                    this.vplProcessInfo = "connected... ";                   
                this.monitoringSocket.onerror = ({data}) => { 
                    this.vplProcessInfo = data ; 
                    };                    
                this.monitoringSocket.onmessage = ({data}) => {
                    if (data.substring(data.length - 3) == 'seg') data = data.substring(0, data.length - 2) + '.'
                    this.vplProcessInfo = data ;

                    if (data == 'retrieve:') { // compilation successfull, start running
                            let d = { adminticket: tickets.adminticket }
                            
                            this.vplProcessInfo = 'reading result'
                            axios.post('/vpl-get-result', d, this.$store.getters.getAxiosConfig )
                            .then((res) => {
                                // set data to var
                                this.vplCompilerInfo = '<pre>' + res.data.compilation + '</pre>'
                                this.vplExecutionInfo = '<pre>' + res.data.execution + '</pre>'
                                this.vplProcessInfo = ''
                                if (res.data.compilation >'') this.showCompileInfo = true
                                else this.showExecuteInfo = true
                                let pos = res.data.execution.indexOf('Grade :=>>')
                                if (pos>-1) this.grade = res.data.execution.substring(pos+10).trim()
                                console.log(res.data.execution)
                                if (this.grade == '100') this.showExecuteInfo = false
                            })
                            .catch(error => {
                                this.vplProcessInfo = 'error ' + error
                                this.$store.commit('setFeedback', error)
                            })
                    }
                    if (data == 'close:') { 
                        this.isRunning = false 
                        this.vplProcessInfo = ''
                    }
                }
            }
        },
            getResultColor() {
                if (this.grade == 0 && this.vplExecutionInfo == '') return 'primary'
                if (this.grade == 0) return 'red'
                if (this.grade == 100) return 'green'
                return 'orange'
            },
            getCompilerColor() {
                if (this.vplCompilerInfo.lenght > 11) return 'red'
                if (this.vplCompilerInfo == '' && this.vplExecutionInfo == '') return 'primary'
                return 'green'
            },
            getCmOptions() {
                return {
                    tabSize: 4,
                    styleActiveLine: true,
                    lineNumbers: true,
                    line: true,
                    mode: this.$store.getters.getEditorType,
                    lineWrapping: false,
                    extraKeys: {'Ctrl-Space': 'autocomplete',
                            'F11'(cm) {
                                cm.setOption("fullScreen", !cm.getOption("fullScreen"))
                            },
                            'Esc'(cm) {
                            if (cm.getOption("fullScreen")) cm.setOption("fullScreen", false)
                        }
                    }
                }
            },
        onPickFile(index) {
            this.binaryFileIndex = index
            this.$refs.fileInput.click()
        },
        onFilePicked(event) {
            const files = event.target.files
            const fileReader = new FileReader()
              fileReader.addEventListener('load', () =>  {
                const data = fileReader.result
                let ind = data.indexOf('base64,')
                this.mycontent.filesToKeep[this.binaryFileIndex] = data.substring(ind+7)
                this.changeCollapse('filesToKeep')
                }
            )
            fileReader.readAsDataURL(files[0])
            this.changeCollapse('filesToKeep')
        },
        copyKeep() {
            this.changeCollapse('filesToKeep')
            const keeps = this.getContent8fromStore(this.getLanguagePrimary.id).filesToKeep
            for(let i = 0; i < keeps.length; i++) {
                this.mycontent.filesToKeep[i] = '' + keeps[i]
            }
            this.changeCollapse('filesToKeep')
        },
        copyConfig() {
            this.changeCollapse('configFiles')
            const confs = this.getContent8fromStore(this.getLanguagePrimary.id).configFiles
            for(let i = 0; i < confs.length; i++) {
                this.mycontent.configFiles[i] = '' + confs[i]
            }
            this.changeCollapse('configFiles')
        }
    } 

}
</script>


<style>
    .customTabTitle div {
        text-transform: none;  
    }
</style>


